import React from "react";
import styled from "styled-components";

const SpeedControlCapsule = ({ speed, onSpeedChange, speeds }) => {
  const currentIndex = speeds.findIndex(s => s.value === speed);
  
  const handleDecrease = () => {
    if (currentIndex > 0) {
      onSpeedChange(speeds[currentIndex - 1].value);
    }
  };

  const handleIncrease = () => {
    if (currentIndex < speeds.length - 1) {
      onSpeedChange(speeds[currentIndex + 1].value);
    }
  };

  const currentLabel = speeds[currentIndex]?.label || "1.00x";

  return (
    <CapsuleWrapper>
      <CapsuleContainer>
        <SpeedButton 
          onClick={handleDecrease} 
          disabled={currentIndex === 0}
          position="left"
        >
          −
        </SpeedButton>
        <SpeedValue>{currentLabel}</SpeedValue>
        <SpeedButton 
          onClick={handleIncrease} 
          disabled={currentIndex === speeds.length - 1}
          position="right"
        >
          +
        </SpeedButton>
      </CapsuleContainer>
    </CapsuleWrapper>
  );
};

export default SpeedControlCapsule;

const CapsuleWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 32px;
`;

const CapsuleContainer = styled.div`
  display: flex;
  align-items: center;
  background: rgba(50, 48, 70, 0.4);
  border-radius: 16px;
  overflow: hidden;
  height: 28px;
`;

const SpeedButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 28px;
  background: ${({ theme, disabled }) => disabled ? 'transparent' : 'rgba(45, 49, 72, 1)'};
  border: none;
  border-radius: ${({ position }) => 
    position === 'left' ? '16px 0 0 16px' : 
    position === 'right' ? '0 16px 16px 0' : '0'};
  font-size: 18px;
  font-weight: 400;
  color: ${({ theme, disabled }) => disabled ? theme.menu.secondaryTextColor : 'rgba(146, 139, 237, 1)'};
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  opacity: ${({ disabled }) => disabled ? 0.4 : 1};

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

const SpeedValue = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  min-width: 40px;
  text-align: center;
`;